import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllKits, deleteKit } from "../../reducer/actions";
import EditKitModal from "./EditKitModal";
import styles from "./KitList.module.css";

const KitList = () => {
  const dispatch = useDispatch();
  const kits = useSelector((state) => state.kits);
  const [selectedKit, setSelectedKit] = useState(null); // Para gestionar el kit seleccionado para edición
  const [isModalOpen, setIsModalOpen] = useState(false); // Para abrir y cerrar el modal

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getAllKits()); // Obtener todos los kits al montar el componente
  }, [dispatch]);

  const handleDeleteKit = async (id) => {
    await dispatch(deleteKit(id)); // Despacha la acción para eliminar el kit
    dispatch(getAllKits()); // Obtén la lista actualizada de kits después de eliminar
  };

  const handleEditKit = (kit) => {
    setSelectedKit(kit); // Establece el kit seleccionado para editar
    setIsModalOpen(true); // Abre el modal de edición
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Cierra el modal de edición
    setSelectedKit(null); // Limpia el kit seleccionado
  };

  return (
    <div className={styles.kitList}>
      <h2>Lista de Kits</h2>
      {kits.map((kit) => (
        <div key={kit.id} className={styles.kit}>
          <img src={kit.image} alt={kit.name} className={styles.kitImage} />
          <p className={styles.kitName}>{kit.name}</p>
          <button
            className={styles.deleteButton}
            onClick={() => handleDeleteKit(kit.id)}
          >
            Eliminar
          </button>
          <button
            className={styles.editButton}
            onClick={() => handleEditKit(kit)}
          >
            Editar
          </button>
        </div>
      ))}

      {/* Modal de edición */}
      {isModalOpen && selectedKit && (
        <EditKitModal kit={selectedKit} closeModal={handleCloseModal} />
      )}
    </div>
  );
};

export default KitList;
